import Button from '~/client/shared/Button';

const getButtonType = (
  status?: TournamentStatus,
  canClaim?: boolean,
  optedIn?: boolean,
) => {
  if (status === 'past' && canClaim && optedIn) {
    return 'primary';
  }
  if (status !== 'past' && !optedIn) {
    return 'primary';
  }
  return 'secondary';
};

type Props = {
  defaultTranslation: string;
  pastTranslation: string;
  handleAction: () => void;
  toggleDialog: () => void;
  loading: boolean;
  status: TournamentStatus;
  iAmOptedIn?: boolean;
  canClaimPrize?: boolean;
  isAutomaticallyReleased?: boolean;
  isDisabled?: boolean;
};

const ActionButton: FC<Props> = ({
  defaultTranslation,
  pastTranslation,
  canClaimPrize,
  isAutomaticallyReleased,
  handleAction,
  iAmOptedIn,
  loading,
  status,
  toggleDialog,
  isDisabled,
}) => {
  const handleClick = () => {
    if (!isAutomaticallyReleased && canClaimPrize) {
      toggleDialog();
    } else {
      handleAction();
    }
  };
  return (
    <Button
      disabled={isDisabled}
      variant={getButtonType(status, canClaimPrize, iAmOptedIn)}
      fullWidth
      onClick={handleClick}
      animation={loading ? 'progress' : undefined}
      className="whitespace-normal font-normal leading-none"
    >
      {status === 'past' ? pastTranslation : defaultTranslation}
    </Button>
  );
};

export default ActionButton;
